// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3JcY0","upload":"Small_upload__2b3fU","imageWrap":"Small_imageWrap__1ASSt","removeBtn":"Small_removeBtn__16c6P"};